export default __webpack_public_path__ + "static/media/precios_LEED_feb_eng-sumeV.5cd1eb61.png";